module.exports = __webpack_public_path__ + "0f272669510726e9f9bd6bc283e7f04b.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=600!./src/components/cover/teaser.jpg?size=600w
// module id = 32
// module chunks = 1